import {
  FormControlLabel as MUIFormControlLabel,
  FormControlLabelProps,
} from '@mui/material';

export { type FormControlLabelProps } from '@mui/material';

export function FormControlLabel(props: FormControlLabelProps) {
  return <MUIFormControlLabel {...props} />;
}
